import DataTable from "../../../../components/Base/DataTable";
import { useNavigate } from "react-router-dom";
import React, { Fragment, useCallback, useState, useEffect, useRef } from "react";
import Input from "../../../../components/Base/Input";
import { dateFormatter } from "../utils/dateFormatter";
import useMap from "../../../../hooks/useMap";
import PaymentSummary from "../../../../components/Compound/PaymentSummary";
import ButtonBar from "../../../../components/Base/ButtonBar";
import Button from "../../../../components/Base/Button";
import ElectronicTallyTicket from "../components/TicketsBancoAgrario/TicketsElectronicTally/ElectronicTallyTicket";
import Modal from "../../../../components/Base/Modal";
import { useReactToPrint } from "react-to-print";
import { postGetSupportElectronicTally, postPaginatedElectronicTally } from "../utils/postPaginatedElectronicTally";
import { getLabelByValue } from "./RegisterElectronicTally";
import SimpleLoading from "../../../../components/Base/SimpleLoading";
import { useAuth } from "../../../../hooks/AuthHooks";
import { onChangeNumber } from "../../../../utils/functions";

const initialSearchFilters = new Map([
  ["id_electronic_tally", ""],
  ["movement_date", ""],
  ["shipping_date", ""],
  ["page", 1],
  ["limit", 10],
]);
const HOURS_CORRECTION = 5;
const ListElectronicTally = () => {
  const [tallies, setTallies] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(false);
  const { roleInfo } = useAuth();
  const [summaryDefault, setSummaryDefault] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [statusStep, setStatusStep] = useState(0);
  const navigate = useNavigate();
  const [supportUrl, setSupportUrl] = useState("");
  const [isNextPage, setIsNextPage] = useState(false);
  const printDiv = useRef();
  const [filtersReady, setFiltersReady] = useState(false);
  const handlePrint = useReactToPrint({
    content: () => printDiv.current,
  });

  const closeModal = useCallback(async () => {
    setShowModal(0);
    setStatusStep(0);
    setSupportUrl('');
    setShowModal(false);
  }, []);


  const [searchFilters, { setAll: setSearchFilters, set: setSingleFilter }] =
    useMap(initialSearchFilters);

  const fetchTallies = useCallback(async () => {
    if (!filtersReady) return;
    const bodyObj = {};
    for (const [key, value] of searchFilters.entries()) {
      if (value !== "" && value !== null && value !== undefined) {
        bodyObj[key] = value;
      }
    }

    try {
      setLoading(true)
      const res = await postPaginatedElectronicTally(bodyObj);
      setIsNextPage(res?.next_exist ?? false);
      setTallies(res?.tallies ?? []);
    } catch (err) {
      console.error("Error obteniendo punteos:", err);
    }finally {
      setLoading(false)

    }
  }, [searchFilters,filtersReady]);

  useEffect(() => {
    if (filtersReady) return;
    if(roleInfo){
      if (roleInfo?.id_comercio) {
        setSingleFilter("commerce_id", roleInfo.id_comercio);
      }
      setFiltersReady(true)
    }

  }, [roleInfo, setSingleFilter, filtersReady]);
  const fetchSupport = useCallback(async (supportKey) => {
    const bodyObj = {
      support: supportKey,
    };
    setLoading(true)
    try {
      const res = await postGetSupportElectronicTally(bodyObj);
      setSupportUrl(res?.url);

    } catch (err) {
      console.error("Error obteniendo soporte:", err);
    }finally {
      setLoading(false)
    }
  }, [selected?.support]);


  useEffect(() => {
    if (!filtersReady) return;
    fetchTallies();
  }, [fetchTallies,filtersReady]);


  return (
    <div className="w-full flex flex-col justify-center items-center my-8">
      <h1 className="text-3xl">Cargue de Soporte</h1>
      <DataTable
        title="Punteos"
        headers={[
          "ID Transacción",
          "Tipo de Proceso",
          "Fecha Movimiento",
          "Fecha Envío",
          "Número Sticker Contenedor",
          "Número Precinto",
          "Número de Tula",
          "Observaciones",
          "Nombre Usuario",
          "Fecha Cargue Soporte",
        ]}
        data={tallies.map(
          ({
             id,
             process_type,
             movement_date,
             shipping_date,
             container_sticker_number,
             seal_number,
             tula_number,
             observations,
             user_name,
             created_support,
           }) => {
            const addHours = (dateStr, hours) => {
              const date = new Date(dateStr);
              if (isNaN(date.getTime())) return "-";
              date.setHours(date.getHours() + hours);
              return dateFormatter.format(date);
            };

            return {
              id,
              process_type: getLabelByValue(process_type),
              movement_date: movement_date ? addHours(movement_date, HOURS_CORRECTION) : "-",
              shipping_date: shipping_date ? addHours(shipping_date, HOURS_CORRECTION) : "-",
              container_sticker_number,
              seal_number,
              tula_number,
              observations,
              user_name,
              created_support: created_support ? addHours(created_support, HOURS_CORRECTION) : "-",
            };
          }
        )}
        onClickRow={(_, index) => {
          const item = tallies[index];
          setSelected(item);
          if(item.support){
            fetchSupport(item.support)
            setStatusStep(2)
          }else(
            setStatusStep(1)
          )
          const date = new Date(item?.created_support || item?.shipping_date);
          date.setHours(date.getHours() + 5);
          setSummaryDefault({
            "ID Transacción": item?.id,
            "Tipo de Proceso": getLabelByValue(item?.process_type),
            Fecha: dateFormatter.format(date),
          });
          setShowModal(true);
        }}
        tblFooter={
          <Fragment>
            <DataTable.LimitSelector
              defaultValue={searchFilters.get("limit")}
              onChangeLimit={(limit) => {
                setSingleFilter("limit", limit);
              }}
            />
            <DataTable.PaginationButtons
              onClickNext={(_) =>
                setSingleFilter("page", (oldPage) =>
                  isNextPage ? oldPage + 1 : oldPage
                )
              }
              onClickPrev={(_) =>
                setSingleFilter("page", (oldPage) =>
                  oldPage > 1 ? oldPage - 1 : oldPage
                )
              }
            />
          </Fragment>
        }
        onChange={(ev) => {
          setSearchFilters((old) => {
            if (!ev.target.name) return old;
            const copy = new Map(old)
              .set(
                ev.target.name,
                ["id_electronic_tally", "id_comercio", "id_usuario"].includes(ev.target.name)
                  ? onChangeNumber(ev)
                  : ev.target.value
              )
              .set("page", 1);
            return copy;
          });
        }}
      >
        <Input
          id="movement_date"
          name="movement_date"
          label="Fecha Movimiento"
          type="date"
          value={searchFilters.get("movement_date")}
        />
        <Input
          id="shipping_date"
          name="shipping_date"
          label="Fecha Envío"
          type="date"
          value={searchFilters.get("shipping_date")}
        />
        <Input
          id="id_electronic_tally"
          name="id_electronic_tally"
          label="ID Transacción"
          type="tel"
          maxLength={15}
          value={searchFilters.get("id_electronic_tally") ?? ""}
          onChange={() => {}}
        />

      </DataTable>
      <SimpleLoading show={loading||!filtersReady}></SimpleLoading>
      <Modal show={showModal} handleClose={closeModal}>
        {statusStep === 1 && (
          <PaymentSummary title={'Punteo Electrónico'} subtitle={'Realice el cargue del soporte para continuar con el proceso'} summaryTrx={summaryDefault}>
            <ButtonBar>
              <Button
                type="submit"
                onClick={()=>{setStatusStep(3)}}
              >
                Reimprimir
              </Button>
              <Button onClick={()=>{

                navigate("/GestionTransaccional/punteo-electronico/cargar",{
                  state: {
                    id: selected.id,
                  },});

              }} >
                Cargar
              </Button>
              <Button onClick={closeModal} >
                Cancelar
              </Button>
            </ButtonBar>
          </PaymentSummary>
        )}
        {statusStep === 2 && (
          <div className="flex flex-col items-center gap-4">
            {selected?.support && (
              <div className="w-full max-w-md bg-white shadow-md rounded-xl p-4 border border-gray-200">
                <h2 className="text-lg font-semibold text-center mb-2">Comprobante</h2>
                <div ref={printDiv} className="w-full h-auto overflow-hidden rounded-lg">
                  <SimpleLoading show={loading}></SimpleLoading>
                  <img

                    src={supportUrl}
                    alt="Comprobante"
                    className="w-full h-auto object-contain rounded-md"
                  />
                </div>
              </div>
            )}

            {/* Botones */}
            <ButtonBar>
              <Button onClick={handlePrint}>Imprimir</Button>
              <Button onClick={closeModal}>Cerrar</Button>
            </ButtonBar>
          </div>
        )}
        {statusStep === 3 && (
          <div className="flex flex-col items-center gap-4">
            <ElectronicTallyTicket refPrint={printDiv} type={'Reimpresión'} ticket={selected.ticket} />
            <ButtonBar>
              <Button onClick={handlePrint}>Imprimir</Button>
              <Button onClick={closeModal}>Cerrar</Button>
            </ButtonBar>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default ListElectronicTally;
